import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import AgentDashboard from "@/pages/AgentDashboard";
import ManagerDashboard from "@/pages/ManagerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import { Loader2 } from "lucide-react";

function RoleRouter() {
  const { user, ready } = useAuth();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0a0a0a]">
        <Loader2 className="w-8 h-8 animate-spin text-[#29B6F6]" />
      </div>
    );
  }

  if (!user) return <Login />;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "manager") return <ManagerDashboard />;
  return <AgentDashboard />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="*" element={<RoleRouter />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" theme="light" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
